export {
    APOLLO_STATE_PROP_NAME,
    createApolloClient,
    initializeApollo,
    addApolloState,
    useApollo
} from './createApolloClient';
export * as SsrAuthQueries from './ssr/auth';
